import React from 'react';
import SocialDashboard from './components/SocialDashboard';

import './App.css';

function App() {
  return (
    <div className="App">
      <SocialDashboard />
    </div>
  );
}

export default App;